/* @flow */
/* eslint-disable import/prefer-default-export */

export const USER_SET = 'user/USER_SET';
export const LAST_EMAIL_SET = 'user/LAST_EMAIL_SET';
